// extracted by mini-css-extract-plugin
module.exports = {"grid":"CardGrid_grid__4Vcau"};